import cn from "classnames";
import Loader from "components/shared/loader";
import { messageMediaTypesEnum } from "helpers/enums/messageMediaTypes";
import React, { Component, lazy, Suspense } from "react";
import { Mention, MentionsInput } from "react-mentions";
import { alert } from "services/alert";
import { sendFile, sendMessage } from "sources/messages";

const EmojiPicker = lazy(() => import("./emojiPicker.js"));

export default class ChatFooter extends Component {
    state = {
        currentText: "",
        isLoadingBtn: false,
        lastEvent: null,
    };

    componentDidMount() {
        this.field?.focus();
    }

    recalcFieldHeight = () => {
        this.field.style.height = "1px";
        this.field.style.height = this.field.scrollHeight + 1 + "px";
    };

    setValue = ({ target }) => {
        if (this.state.isLoadingBtn) {
            return;
        }
        this.setState({ currentText: target.value });
        this.recalcFieldHeight();
    };

    sendMessage = () => {
        const { currentText, isLoadingBtn } = this.state;
        const { chatId } = this.props;
        if (!isLoadingBtn && currentText.length) {
            this.setState({ isLoadingBtn: true });
            (this.props.sendMessage ?? sendMessage)({ text: currentText, chatId }).then(() => {
                this.setState({ isLoadingBtn: false, currentText: "" });
                this.recalcFieldHeight();
            });
        }
    };

    eventsHandler = (event) => {
        const { key, ctrlKey, shiftKey } = event;
        if (key === "Enter") {
            event.preventDefault();
            if (ctrlKey || shiftKey) {
                return this.setState({ currentText: this.state.currentText + "\n" });
            }
            if (this.state.currentText.length) {
                return this.sendMessage();
            }
        }
    };

    handleOnPaste = (event) => {
        const files = (event.clipboardData || event.originalEvent.clipboardData).files;

        const filesArr = Array.from(files);
        if (filesArr.length > 5) {
            return alert({ type: "warning", message: "Доступна загрузка не более 5 файлов", title: "Ошибка" });
        }
        if (files.length > 0) {
            this.sendFile({ files: filesArr });
        }
    };

    sendFile = (data = {}) => {
        const { isLoadingBtn } = this.state;
        if (isLoadingBtn) {
            return null;
        }
        const { modal, chatId } = this.props;
        return modal({
            name: "fileUpload",
            propName: "attachedFile",
            windowMod: "wide",
            isMultiple: true,
            ...data,
            uploadFile: (data) => {
                data.body.append("mediaType", messageMediaTypesEnum.File);
                data.body.append("chatId", chatId);

                return (this.props.sendFile ?? sendFile)(data);
            },
        });
    };

    shouldSuggestKeysModalRender = ({ type }) => {
        if (type === "mouseover") {
            return setTimeout(() => {
                this.setState({ lastEvent: type });
            }, 3000);
        }
        return this.setState({ lastEvent: type });
    };

    handleEmojiPickup = (emoji) => {
        const { currentText } = this.state;
        if (this.field) {
            const cursorPosition = this.field.selectionStart || 0;
            const text = currentText.slice(0, cursorPosition) + emoji.native + currentText.slice(cursorPosition);
            this.setState({ currentText: text });
            const newCursorPosition = cursorPosition + emoji.native.length;
            setTimeout(() => {
                this.field.setSelectionRange(newCursorPosition, newCursorPosition);
            }, 10);
        }
    };

    renderSubmit = () => {
        const { isLoadingBtn, currentText, lastEvent } = this.state;

        if (isLoadingBtn) {
            return <Loader prefix="chat-submit" />;
        }

        const cname = cn("chat-footer__submit", { "chat-footer__submit--disabled": !currentText.length });
        const cName =
            lastEvent === "mouseover" && currentText.length
                ? "chat-footer__suggest-keys-modal"
                : "chat-footer__suggest-keys-modal--disabled";

        return (
            <div className="chat-footer__submit-wrapper d-flex">
                <div className={cName}>
                    <span className="chat-footer__suggest-keys-modal-text">
                        Нажмите Ctrl+Enter или Shift+Enter, чтобы перенестись на новую строку
                    </span>
                    <span className="chat-footer__suggest-keys-modal-text">
                        {" "}
                        Нажмите Enter, чтоб отправить сообщение{" "}
                    </span>
                    <div className="chat-footer__suggest-keys-modal-triangle" />
                </div>
                <Suspense>
                    <EmojiPicker
                        field={this.field}
                        handleEmojiPickup={this.handleEmojiPickup}
                        theme={this.props.theme}
                    />
                </Suspense>
                <div
                    className={cname}
                    onClick={this.sendMessage}
                    onMouseOut={this.shouldSuggestKeysModalRender}
                    onMouseOver={this.shouldSuggestKeysModalRender}
                />
            </div>
        );
    };

    render() {
        const { currentText } = this.state;
        return (
            <div className="chat__footer chat-footer">
                <div className="chat-footer__file" onClick={this.sendFile} />
                <div className="w-100">
                    <MentionsInput
                        forceSuggestionsAboveCursor
                        value={currentText}
                        onChange={this.setValue}
                        onKeyDown={this.eventsHandler}
                        onPaste={this.handleOnPaste}
                        inputRef={(e) => (this.field = e)}
                        placeholder="Введите текст"
                        className="chat-footer__mentions-input"
                    >
                        <Mention
                            appendSpaceOnAdd
                            markup="[user=__id__]__display__[/user]"
                            data={
                                this.props.info?.users?.map((user) => ({ display: user.fullName, id: user.id })) || []
                            }
                            className="chat-footer__mention"
                        />
                    </MentionsInput>
                </div>
                {this.renderSubmit()}
            </div>
        );
    }
}
